import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserManagementService } from '../service/userManagement.service';
import { ChangePasswordModel } from '../model/FormsEntity/resetPassword';
import { NotificationService } from '../core/core.module';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent {
  resetPass:ChangePasswordModel = new ChangePasswordModel();
  statusMessage:string;
  resetPassword = this.fb.group({
    mobileNumber:[null,Validators.compose([
      Validators.required,Validators.pattern('^[0-9]{10}$')
    ])],
    oldPassword:[null,Validators.required],
    newPassword:[null,Validators.required],
  });

  constructor(private fb: FormBuilder,
    private userMenage :UserManagementService,
    private router: Router,
    private notification:NotificationService ) {}

  onSubmit(): void {
    if (this.resetPassword.invalid) {
      return;
      }
    this.userMenage.resetPassword(this.resetPass).subscribe(data=>{
      // console.log(data);
      if(data && data.error){
        this.notification.warn(data.error.errorMessage);
      }else if(data && data.status){
        this.statusMessage = data.status.detailMessage;
        this.notification.success(data.status.detailMessage);
        this.router.navigate(['/login']);
      }
    })
  }
}
